import { render, staticRenderFns } from "./AttachmentsDb.vue?vue&type=template&id=1096c826"
import script from "./AttachmentsDb.ts?vue&type=script&lang=ts&external"
export * from "./AttachmentsDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports